import React from 'react';
import { AxiosRequestConfig } from 'axios';
import { TakeEffect } from 'redux-saga/effects';

interface ResourceDecoratorContextProps {
  requestResolvers?: (
    (requestConfig: AxiosRequestConfig) => Promise<AxiosRequestConfig> |
    Generator<TakeEffect, AxiosRequestConfig, any>
  )[];
}

const ResourceDecoratorContext = React.createContext<ResourceDecoratorContextProps>({});

export default ResourceDecoratorContext;
